/**
 * DevExtreme (esm/__internal/viz/core/themes/fluent/index.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
const themes = [{
  baseThemeName: "material.blue.light",
  theme: {
    name: "fluent.blue.light"
  }
}, {
  baseThemeName: "fluent.blue.light",
  theme: {
    name: "fluent.blue.light.compact"
  }
}, {
  baseThemeName: "fluent.blue.light",
  theme: {
    name: "fluent.saas.light"
  }
}, {
  baseThemeName: "fluent.saas.light",
  theme: {
    name: "fluent.saas.light.compact"
  }
}, {
  baseThemeName: "material.blue.dark",
  theme: {
    name: "fluent.blue.dark"
  }
}, {
  baseThemeName: "fluent.blue.dark",
  theme: {
    name: "fluent.blue.dark.compact"
  }
}, {
  baseThemeName: "fluent.blue.dark",
  theme: {
    name: "fluent.saas.dark"
  }
}, {
  baseThemeName: "fluent.saas.dark",
  theme: {
    name: "fluent.saas.dark.compact"
  }
}];
export default themes;